export default String.raw`
.sitemap-container {
    margin: 40px auto;
    line-height: 1.6;
}

.sitemap-sections {
    list-style: none;
    margin: 0;
    padding: 0;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 40px;
}

.sitemap-title {
    font-size: 24px;
}

.sitemap-group-title {
    font-size: 18px;
    font-weight: 600;
    color: $primaryColorFont;
    margin: 0 0 20px 0;
    padding-bottom: 8px;
    text-transform: none;
}

.sitemap-links {
    list-style: none;
    margin: 0;
    padding: 0;
    
    li {
        margin: 0 0 12px 0;
        padding: 0;
        
        a {
            color: $iconColors;
            text-decoration: none;
            font-size: 14px;
            font-weight: 400;
            line-height: 1.5;
            padding: 4px 0;
            transition: color 0.2s ease;
            
            &:hover {
                color: $iconColorsHover;
                text-decoration: underline;
            }
        }
    }
}
`